import { enums } from '../constants'

const normalizeStringForIdentifier = (value) => {
  if (!value) return ''
  return String(value)
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .replace(/[^a-zA-Z0-9]+/g, ' ')
    .trim()
}

export const getTipoBoletoId = (tipoBoleto) => {
  if (tipoBoleto == null) return null
  if (typeof tipoBoleto === 'number') return tipoBoleto

  if (typeof tipoBoleto === 'object') {
    if (tipoBoleto.id != null) return tipoBoleto.id
    if (tipoBoleto.codigo != null) return tipoBoleto.codigo
  }

  return null
}

export const findTipoBoletoInLookup = (tipoBoleto, lookup = enums.TipoBoletoLookup) => {
  const id = getTipoBoletoId(tipoBoleto)
  if (id == null) return null
  return lookup.find((item) => item.id === id) || null
}

export const isTipoBoletoInLookup = (tipoBoleto, lookup = enums.TipoBoletoLookup) => {
  return !!findTipoBoletoInLookup(tipoBoleto, lookup)
}

export const isObjectInTipoBoletoList = (tipoBoleto, list = enums.TipoBoletoLookup) => {
  const id = getTipoBoletoId(tipoBoleto)
  if (id == null) return false
  return Array.isArray(list) && list.some((item) => item?.id === id)
}

export const isTipoBoletoEqualToEnum = (tipoBoleto, enumItem) => {
  const idA = getTipoBoletoId(tipoBoleto)
  const idB = getTipoBoletoId(enumItem)
  if (idA == null || idB == null) return false
  return idA === idB
}

// Mesma ideia do resolveValueFn usado no ConfiguracaoBoletoForm
export const resolveTipoBoletoFromLookup = (tipoBoleto, lookup = enums.TipoBoletoLookup) => {
  const resolved = findTipoBoletoInLookup(tipoBoleto, lookup)
  return resolved || tipoBoleto
}

// Métodos diretos (um por item do enums.TipoBoletoLookup)
export const isTipoBoletoAilos = (tipoBoleto) => isTipoBoletoEqualToEnum(tipoBoleto, enums.TipoBoleto.AILOS)
export const isTipoBoletoCnab240 = (tipoBoleto) => isTipoBoletoEqualToEnum(tipoBoleto, enums.TipoBoleto.CNAB_240)
export const isTipoBoletoBradesco = (tipoBoleto) => isTipoBoletoEqualToEnum(tipoBoleto, enums.TipoBoleto.BRADESCO)
export const isTipoBoletoSicoob = (tipoBoleto) => isTipoBoletoEqualToEnum(tipoBoleto, enums.TipoBoleto.SICOOB)
export const isTipoBoletoCnab400 = (tipoBoleto) => isTipoBoletoEqualToEnum(tipoBoleto, enums.TipoBoleto.CNAB_400)
export const isTipoBoletoPix = (tipoBoleto) => isTipoBoletoEqualToEnum(tipoBoleto, enums.TipoBoleto.PIX)
export const isTipoBoletoSantander = (tipoBoleto) => isTipoBoletoEqualToEnum(tipoBoleto, enums.TipoBoleto.SANTANDER)
export const isTipoBoletoItau = (tipoBoleto) => isTipoBoletoEqualToEnum(tipoBoleto, enums.TipoBoleto.ITAU)
export const isTipoBoletoCaixa = (tipoBoleto) => isTipoBoletoEqualToEnum(tipoBoleto, enums.TipoBoleto.CAIXA)
export const isTipoBoletoSicredi = (tipoBoleto) => isTipoBoletoEqualToEnum(tipoBoleto, enums.TipoBoleto.SICREDI)
export const isTipoBoletoBB = (tipoBoleto) => isTipoBoletoEqualToEnum(tipoBoleto, enums.TipoBoleto.BB)
export const isTipoBoletoCnab = (tipoBoleto) =>
  isTipoBoletoEqualToEnum(tipoBoleto, enums.TipoBoleto.CNAB_240) ||
  isTipoBoletoEqualToEnum(tipoBoleto, enums.TipoBoleto.CNAB_400) ||
  isTipoBoletoEqualToEnum(tipoBoleto, enums.TipoBoleto.PIX)

// Opcional: mapa com guards gerados a partir do lookup atual
export const TipoBoletoLookupGuards = Object.keys(enums.TipoBoleto).reduce((acc, key) => {
  const base = normalizeStringForIdentifier(key)
  const pascal = base
    .toLowerCase()
    .replace(/(?:^|\s)(\w)/g, (_, c) => c.toUpperCase())
    .replace(/\s+/g, '')

  const methodName = `isTipoBoleto${pascal}`
  if (!methodName || acc[methodName]) return acc

  acc[methodName] = (tipoBoleto) => isTipoBoletoEqualToEnum(tipoBoleto, enums.TipoBoleto[key])
  return acc
}, {})
